/**
 * @file   src\Pages\AddCarWash.tsx
 * @brief  AddCarWash page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import {  React,  Container, Button,  useNavigate, useLocation} from '../utils/thirdpartyComponents';
import Successicon from "../assets/images/success-icon.svg";
import "../styles/subscriptions.scss";
import { pageURLs } from '../utils/pageUrls';

const PaymentSuccess = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const orderId = location.state?.orderId || 'Unknown';
return (
   
    <div className='manage-subscription-container'>
        <Container>
       
            
            <div className='cw-form-outer-wrap'>
                <div className="cw-form-container success-outer-wrap d-flex align-items-center justify-content-center">
                    <div className="payment-success text-center mx-auto">
                        <div className="icon"><img src={Successicon} alt="Car Wash App" /></div>
                        <h2 className='f-bold'>Payment Successful!</h2>
                        <h4 className='f-medium'>Your payment is successful.Your order has been placed with Order number: <span>{orderId}</span></h4>
                        <Button variant="outline-primary" className='outline-btn f-bold'  onClick={()=>{navigate("/"+pageURLs.order_hardware)}} title='Place Another Order'>Place Another Order</Button>
                        <p>Note: To place another order for a new location.</p>
                    </div>
                </div>
                <div className="btn-sec d-flex justify-content-end">
                    <Button variant="primary" className="primary-btn db-btn" onClick={()=>{navigate("/"+pageURLs.dashboard)}} title='Proceed To Dashboard'>Proceed To Dashboard</Button>
                </div>
            </div>
        </Container>
    </div>
)
}

export default PaymentSuccess;
